/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManOfTheMatchListElementList = {
    type: 'array',
    contains: {
        type: 'ManOfTheMatchListElement',
    },
} as const;
